import React from "react";
import { connect } from "react-redux";
import classnames from "classnames";

const mapState = (state) => {
	return {
		"poliza": state.polizas.poliza
	};
};

class ConductorPoliza extends React.Component {
	render() {
		let condDireccion = "", condNumExt = "", condNumInt = "", condMunicipio = "", condEstado = "", condCorreo = "", condCP = "", condColonia = "", condTelefono = "";
		let imgConductor;
		let grupo = (this.props.poliza.generales.cveClasificacionSeguro == "06" || this.props.poliza.generales.cveClasificacionSeguro == "05");
		let classes = classnames({
			"col-md-6": !grupo,
			"col-md-12": grupo,
			"col-xs-12": true
		});
        
		if ( this.props.poliza.generales.cveRamo == "A") {
			if ( this.props.poliza.conductor.direccion && this.props.poliza.conductor.direccion.length > 0 ) {
				condDireccion = this.props.poliza.conductor.direccion[0].calle;
				condNumInt = this.props.poliza.conductor.direccion[0].numInt;
				condNumExt = this.props.poliza.conductor.direccion[0].numExt;
				condMunicipio = this.props.poliza.conductor.direccion[0].municipio;
				condEstado = this.props.poliza.conductor.direccion[0].estado;
				condCP = this.props.poliza.conductor.direccion[0].codPostal;
				condColonia = this.props.poliza.conductor.direccion[0].colonia;
			}

			if ( this.props.poliza.conductor.mediosContacto && this.props.poliza.conductor.mediosContacto.correo && this.props.poliza.conductor.mediosContacto.correo.length > 0 ) {
				condCorreo = this.props.poliza.conductor.mediosContacto.correo[0];
			}

			if ( this.props.poliza.conductor.mediosContacto && this.props.poliza.conductor.mediosContacto.telefono && this.props.poliza.conductor.mediosContacto.telefono.length > 0 ) {
				condTelefono = this.props.poliza.conductor.mediosContacto.telefono[0];
			}
		}
        
		switch (this.props.poliza.generales.cveRamo) {
		case "A":
			imgConductor = require("../img/icon-conductor.svg");
			break;
		}
        
		return <div className="card perfil-card mt-34">
			<i><img src={ imgConductor } alt="" className="pad-right-10" /></i><span className="blue-text detalle-seccion">Conductor habitual</span>
			<div className="row">
				<div className={ classes }>
					<ul className="list-divider mt-25">
						<li className="clearfix">
							<div className="pull-left">
								<p><b>Nombre</b></p>
							</div>
							<div className="pull-right">
								<div className="gray-text texto15">
									<p name="nombreConductor">{ this.props.poliza.conductor.nombres } { this.props.poliza.conductor.apellidoPaterno } { this.props.poliza.conductor.apellidoMaterno }</p>
								</div>
							</div>
						</li>
						<li className="clearfix">
							<div className="pull-left">
								<p><b>RFC</b></p>
							</div>
							<div className="pull-right">
								<div className="gray-text texto15">
									<p name="rfcConductor">{ this.props.poliza.conductor.rfc }</p>
								</div>
							</div>
						</li>
						<li className="clearfix">
							<div className="pull-left">
								<p><b>CURP</b></p>
							</div>
							<div className="pull-right">
								<div className="gray-text texto15">
									<p name="curpConductor">{ this.props.poliza.conductor.curp }</p>
								</div>
							</div>
						</li>
						{ !grupo &&
						<div>
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Correo electrónico</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="correoConductor">{ condCorreo }</p>
									</div>
								</div>
							</li>
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Teléfono</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="telefonoConductor">{ condTelefono }</p>
									</div>
								</div>
							</li>
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Estado / Ciudad</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="estadoConductor">{ condEstado }</p>
									</div>
								</div>
							</li>
						</div>
						}
					</ul>
				</div>
				{ !grupo &&
				<div className="col-md-6 col-xs-12">
					<ul className="list-divider mt-25">
						<li className="clearfix">
							<div className="pull-left">
								<p><b>Dirección</b></p>
							</div>
							<div className="pull-right">
								<div className="gray-text texto15">
									<p name="direccionConductor">{ condDireccion }</p>
								</div>
							</div>
						</li>
						<li className="clearfix">
							<div className="pull-left">
								<p><b>Número Interior</b></p>
							</div>
							<div className="pull-right">
								<div className="gray-text texto15">
									<p name="numInteriorConductor">{ condNumInt }</p>
								</div>
							</div>
						</li>
						<li className="clearfix">
							<div className="pull-left">
								<p><b>Número exterior</b></p>
							</div>
							<div className="pull-right">
								<div className="gray-text texto15">
									<p name="numExteriorConductor">{ condNumExt }</p>
								</div>
							</div>
						</li>
						<li className="clearfix">
							<div className="pull-left">
								<p><b>Colonia</b></p>
							</div>
							<div className="pull-right">
								<div className="gray-text texto15">
									<p name="coloniaConductor">{ condColonia }</p>
								</div>
							</div>
						</li>
						<li className="clearfix">
							<div className="pull-left">
								<p><b>Código postal</b></p>
							</div>
							<div className="pull-right">
								<div className="gray-text texto15">
									<p name="codigoPostalConductor">{ condCP }</p>
								</div>
							</div>
						</li>
						<li className="clearfix">
							<div className="pull-left">
								<p><b>Delegación / Municipio</b></p>
							</div>
							<div className="pull-right">
								<div className="gray-text texto15">
									<p name="delegacionMunicipioConductor">{ condMunicipio }</p>
								</div>
							</div>
						</li>
					</ul>
				</div>
				}
			</div>
		</div>;
	}
}

export default connect(mapState)(ConductorPoliza);


// WEBPACK FOOTER //
// ./src/home/conductor.cmpt.js